import * as ChangeContact from 'assets/js/pages/contacts/single/timeline/timeline-list/change-contact';
import { getResourceTypeFriendly } from 'assets/js/pages/contacts/single/timeline/timeline-list/change-contact/helpers';
import * as DropdownMenu from 'components/dropdown-menu';
import { ContactType } from 'constants/contacts';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentContact } from 'customHooks/useCurrentContact';

interface ActivityItemDropdownProps {
    activity: any;
}

const ActivityItemDropdown = ({ activity }: ActivityItemDropdownProps) => {
    const { accountId } = useCurrentAccount();
    const { data: contact } = useCurrentContact();
    const resourceTypeFriendly = getResourceTypeFriendly(activity);
    const resource = contact.type === ContactType.Company ? 'companies' : 'contacts';
    const transactionId =
        resourceTypeFriendly === 'transaction'
            ? activity.resource?.id
            : activity.resource?.transaction_id;

    return (
        <DropdownMenu.Root>
            <DropdownMenu.EllipsisTrigger
                className="w-5 text-center"
                onClick={event => event.stopPropagation()}
                aria-label="Actions"
            />
            <DropdownMenu.Content onClick={e => e.stopPropagation()}>
                <ChangeContact.Root contact={contact} activity={activity}>
                    <ChangeContact.Trigger asChild>
                        <DropdownMenu.Item onSelect={event => event.preventDefault()}>
                            Reassign {resourceTypeFriendly}
                        </DropdownMenu.Item>
                    </ChangeContact.Trigger>
                </ChangeContact.Root>
                {!!transactionId && (
                    <DropdownMenu.LinkItem
                        to={`/accounts/${accountId}/${resource}/${contact?.id}/transactions/${transactionId}`}
                    >
                        View transaction
                    </DropdownMenu.LinkItem>
                )}
            </DropdownMenu.Content>
        </DropdownMenu.Root>
    );
};

export { ActivityItemDropdown };
